import { Tabs, Progress } from 'antd';
import moment from 'moment';
import { useTreatmentPlan } from '../hooks/useTreatmentPlan';
import TreatmentPlanHeader from './TreatmentPlan/TreatmentPlanHeader';
import DateDetailView from './TreatmentPlan/DateDetailView';

export const TreatmentPlanTable = ({
    patientPlanData,
    treatmentName,
    handlePlanChange,
    SetModel,
    formikProps,
    patientDetail,
    patientPlanList,
    roomName,
    roomType
}) => {
    const {
        selectedDateIndex,
        setSelectedDateIndex,
        allDates,
        dataSource,
        formatTime,
        calculateDuration,
        getTimePeriod,
        getDateCompletion,
        getDateStatus,
        handlePlanChangeWithFeedback
    } = useTreatmentPlan(patientPlanData, handlePlanChange);

    const getStatusColor = (completion) => {
        if (completion === 100) return '#52c41a';
        if (completion > 0) return '#faad14';
        return '#d9d9d9';
    };

    const dateTabs = allDates.map((date, index) => {
        const completion = getDateCompletion(date);
        const { isToday, isPast } = getDateStatus(date);
        const formattedDate = moment(date).format('DD MMM');
        const dayName = moment(date).format('ddd');

        return {
            key: index.toString(),
            label: (
                <div style={{ textAlign: 'center', padding: '4px 8px', minWidth: '80px' }}>
                    <div style={{
                        fontSize: '13px',
                        fontWeight: '600',
                        color: isToday ? '#1890ff' : isPast ? '#8c8c8c' : '#262626'
                    }}>
                        {formattedDate}
                    </div>
                    <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '2px' }}>
                        {dayName}{isToday && ' 📍'}
                    </div>
                    <Progress
                        percent={completion}
                        size="small"
                        strokeColor={getStatusColor(completion)}
                        showInfo={false}
                        style={{ marginTop: '4px' }}
                    />
                </div>
            ),
            children: (
                <DateDetailView
                    date={date}
                    dataSource={dataSource}
                    handlePlanChange={handlePlanChangeWithFeedback}
                    SetModel={SetModel}
                    isPast={isPast}
                    isToday={isToday}
                    roomName={roomName}
                    roomType={roomType}
                    formatTime={formatTime}
                    calculateDuration={calculateDuration}
                    getTimePeriod={getTimePeriod}
                    formikProps={formikProps}
                    patientDetail={patientDetail}
                    patientPlanList={patientPlanList}
                />
            ),
        };
    });

    return (
        <div style={{
            background: '#fff',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflow: 'hidden',
            marginTop: '20px',
            padding: 0
        }}>
            <TreatmentPlanHeader
                treatmentName={treatmentName}
                allDatesCount={allDates.length}
                dataSourceCount={dataSource.length}
            />

            <div style={{ padding: '0' }}>
                <Tabs
                    activeKey={selectedDateIndex.toString()}
                    onChange={(key) => setSelectedDateIndex(parseInt(key))}
                    type="card"
                    size="large"
                    tabBarStyle={{
                        margin: 0,
                        background: '#fafafa',
                        padding: '12px 24px 0',
                    }}
                    items={dateTabs}
                />
            </div>

            <div style={{
                padding: '12px 24px',
                background: '#f0f5ff',
                borderTop: '1px solid #d6e4ff',
                fontSize: '12px',
                color: '#595959',
                display: 'flex',
                gap: '20px',
                flexWrap: 'wrap',
            }}>
                <div><span style={{ fontWeight: '600' }}>💡 Tip:</span> Click M/E/Em buttons to record doctor rounds</div>
                <div><span style={{ fontWeight: '600' }}>⚡ Auto-Fill:</span> Changes automatically apply to all future dates</div>
            </div>
        </div>
    );
};
